import { render, staticRenderFns } from "./ProcedureCopy.vue?vue&type=template&id=3b0db965&scoped=true&"
import script from "./ProcedureCopy.vue?vue&type=script&lang=js&"
export * from "./ProcedureCopy.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureCopy.vue?vue&type=style&index=0&id=3b0db965&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0db965",
  null
  
)

export default component.exports